function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AddressFinderSuggestion
 *
 * 
 */
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
class AddressFinderSuggestion extends React.Component {
  constructor(props) {
    super(props);
    /**
     * onBlur of element
     */
    _defineProperty(this, "onBlur", () => {
      // close completions
      if (this.state.isLast) {
        this.props.close();
      }
    });
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        id,
        onSelectAddress
      } = this.props;
      const focus = this.hasFocus();
      if (key === 'Enter' && focus) {
        onSelectAddress(id);
        return true;
      }
      return false;
    });
    /**
     * hasFocus
     */
    _defineProperty(this, "hasFocus", () => {
      const {
        address,
        completions
      } = this.props;
      for (let i = 0; i < completions.length; i++) {
        const comp = completions[i];
        if (comp.full_address === address && comp.focus) {
          return true;
        }
      }
      return false;
    });
    const {
      address: _address,
      completions: _completions
    } = props;
    const isLast = _completions[_completions.length - 1].full_address === _address ? true : false;
    this.state = {
      isLast
    };
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    const {
      address,
      id,
      onSelectAddress
    } = this.props;
    const focus = this.hasFocus();
    return /*#__PURE__*/_jsx("div", {
      className: `address-suggestion${focus ? ' focus' : ''}`,
      onClick: () => onSelectAddress(id),
      onBlur: this.onBlur,
      children: address
    });
  }
}
_defineProperty(AddressFinderSuggestion, "defaultProps", {
  address: '',
  id: '',
  completions: []
});
export default AddressFinderSuggestion;